import { render, staticRenderFns } from "./BqFilterColumns.vue?vue&type=template&id=50045301&scoped=true&"
import script from "./BqFilterColumns.vue?vue&type=script&lang=js&"
export * from "./BqFilterColumns.vue?vue&type=script&lang=js&"
import style0 from "./BqFilterColumns.vue?vue&type=style&index=0&id=50045301&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50045301",
  null
  
)

export default component.exports